export * from './item-in-array.module';
export * from './item-in-array.pipe';

